/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_MarcaCarga as MarcaCarga,
  rec_Modal as Modal,
  rec_React as React,
  rec_Ro as Ro,
  rec_api as api,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function FormularioVehiculo({ editar: e, onClose: t, onGuardado: n }) {
  let [r, i] = (0, React.useState)(e?.placa ?? ``),
    [a, o] = (0, React.useState)(e?.tipo ?? ``),
    [s, c] = (0, React.useState)(e?.asientos ?? ``),
    [l, u] = (0, React.useState)(e?.descripcion ?? ``),
    [f, p] = (0, React.useState)(!e || e.activo),
    [m, h] = (0, React.useState)(``),
    [g, _] = (0, React.useState)(!1);
  async function v(t) {
    if ((t.preventDefault(), !g)) {
      (_(!0), h(``));
      try {
        (await api(`/transporte/unidades`, {
          method: `POST`,
          body: JSON.stringify({
            id: e?.id ?? null,
            placa: r,
            tipo: a,
            asientos: s === `` ? null : Number(s),
            descripcion: l,
            activo: f,
          }),
        }),
          n());
      } catch (e) {
        h(e.message);
      } finally {
        _(!1);
      }
    }
  }
  return (
    <Modal
      titulo={e ? e.placa : `Nueva unidad`}
      onClose={t}
      children={
        <form
          onSubmit={v}
          className={`flex flex-col gap-3`}
          children={[
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `Placa`,
                <input
                  autoFocus={!0}
                  value={r}
                  onChange={(e) => i(e.target.value)}
                  className={Lo}
                />,
              ]}
            />,
            <div
              className={`grid grid-cols-2 gap-3`}
              children={[
                <label
                  className={`flex flex-col gap-1 text-sm text-(--text)`}
                  children={[
                    `Tipo`,
                    <select
                      value={/^AUTO/.test(String(a).toUpperCase()) ? `AUTO` : String(a).toUpperCase()}
                      onChange={(e) => o(e.target.value)}
                      className={Lo}
                      required={!0}
                      children={[
                        <option key={`x`} value={``} disabled={!0} children={`Elige el tipo`} />,
                        ...[`AUTO`, `COMBI/VAN`, `COUSTER`, `MINIBUS`, `BUS`, ...(a && !/^(AUTO|COMBI\/VAN|COUSTER|MINIBUS|BUS)/.test(String(a).toUpperCase()) ? [String(a).toUpperCase()] : [])].map((t) => (
                          <option key={t} value={t} children={t} />
                        )),
                      ]}
                    />,
                    /^AUTO/.test(String(a).toUpperCase()) && (
                      <span className={`text-xs`} children={Number(s) >= 6 ? `Queda como AUTO 6-7 (otro precio).` : `4 o 5 asientos. Con 6 o 7 queda como AUTO 6-7.`} />
                    ),
                  ]}
                />,
                <label
                  className={`flex flex-col gap-1 text-sm text-(--text)`}
                  children={[
                    `Asientos`,
                    <input
                      type={`number`}
                      min={`1`}
                      value={s}
                      onChange={(e) => c(e.target.value)}
                      className={Lo}
                    />,
                  ]}
                />,
              ]}
            />,
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `Descripción`,
                <input
                  value={l}
                  onChange={(e) => u(e.target.value)}
                  placeholder={`Opcional`}
                  className={Lo}
                />,
              ]}
            />,
            e && (
              <MarcaCarga
                checked={f}
                onChange={p}
                children={`Se puede asignar a una orden`}
              />
            ),
            m && <p className={`text-sm text-(--error)`} children={m} />,
            <div
              className={`flex justify-end gap-2`}
              children={[
                <button
                  type={`button`}
                  onClick={t}
                  className={zo}
                  children={`Cancelar`}
                />,
                <button
                  type={`submit`}
                  disabled={g}
                  className={Ro}
                  children={g ? `Guardando…` : `Guardar`}
                />,
              ]}
            />,
          ]}
        />
      }
    />
  );
}
